/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue";
import FlexCell from '@/components/FlexCell';
import Rtf from '@/components/Rtf';
import CartFiltrate from './components/CartFiltrate';
import BottomLine from '@/components/BottomLine';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { MUTATION_MALL_ORDERINFOSURE } from '@/store/mutation_types';
import { GetGoodsDetail, CartAdd } from '@/api/mall';
export default {
  data: function data() {
    return {
      imgArray: [],
      prdObj: {},
      specList: [],
      goodsName: '',
      type: -1,
      // 0:只选择规格，1：加入购物车，2：直接购买
      cartShow: false,
      // 是否显示购物车
      goodsId: '',
      goodsDetailId: '',
      num: 1,
      pirce: ''
    };
  },
  components: {
    Swiper: Swiper,
    FlexCell: FlexCell,
    BottomLine: BottomLine,
    Rtf: Rtf,
    CartFiltrate: CartFiltrate
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapState({})), {}, {
    isReal: function isReal() {
      if (this.prdObj.logisticsType == 3) {
        return 0;
      } else {
        return 1;
      }
    },
    //当前具体规格
    nowGoodsDetail: function nowGoodsDetail() {
      var _this = this;

      if (!this.specList) {
        return null;
      }

      if (this.specList.length == 1) {
        return this.specList[0];
      } else {
        if (!this.goodsDetailId) {
          return null;
        } else {
          return this.specList.find(function (x) {
            return x.goodsDetailId == _this.goodsDetailId;
          });
        }
      }
    },
    //总规格
    inventory: function inventory() {
      var specList = this.specList,
          num = 0;

      if (specList && specList.length > 0) {
        var _iterator = _createForOfIteratorHelper(specList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            num += item.inventory;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return num;
      } else {
        return null;
      }
    },
    priceList: function priceList() {
      var specList = this.specList;

      if (specList) {
        var priceList = specList.map(function (x) {
          return x.price;
        });
        return priceList;
      }
    },
    priceMin: function priceMin() {
      var priceList = this.priceList;

      if (priceList) {
        return Math.min.apply(Math, _toConsumableArray(priceList));
      }
    },
    priceMax: function priceMax() {
      var priceList = this.priceList;

      if (priceList) {
        return Math.max.apply(Math, _toConsumableArray(priceList));
      }
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var goodsId = to.query.goodsId;
    console.log(goodsId);
    next(function (vm) {
      if (goodsId) {
        vm.getGoodsDetailAjax(goodsId);
      }
    });
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    MUTATION_MALL_ORDERINFOSURE: MUTATION_MALL_ORDERINFOSURE
  })), {}, {
    cartConfirm: function cartConfirm(result) {
      var goodsDetailId = result.goodsDetailId;
      this.goodsDetailId = result.goodsDetailId;
      this.num = result.num; //加入购物车+直接购买的确定

      if (result.type == 1 || result.type == 2) {
        //规格
        if (this.specList.length > 1) {
          if (!result.goodsDetailId) {
            Public.tips({
              text: '请选择规格'
            });
            return;
          }

          if (this.nowGoodsDetail.inventory <= 0) {
            Public.tips({
              text: '库存不足，请重新选择'
            });
            return;
          }
        } else {
          goodsDetailId = this.nowGoodsDetail.goodsDetailId;
        } //加入购物车


        if (result.type == 1) {
          CartAdd({
            goodsId: this.goodsId,
            goodsQty: result.num,
            goodsSpecifitionId: goodsDetailId
          }).then(function (data) {
            Public.tips({
              text: '添加成功，请在购物车查看~'
            });
          });
        } //直接购买
        else {
          this.buyOrder();
        }
      }

      console.log(result);
    },
    cartClick: function cartClick() {
      console.log('cartClick');
      this.cartShow = true;
      this.type = 1;

      if (!this.goodsDetailId && this.specList) {
        this.goodsDetailId = this.specList[0].goodsDetailId;
      }

      console.log(this.cartShow);
    },
    buyOrderClick: function buyOrderClick() {
      console.log('buyOrderClick');
      this.cartShow = true;
      this.type = 2;

      if (!this.goodsDetailId && this.specList) {
        this.goodsDetailId = this.specList[0].goodsDetailId;
      }
    },
    //点击选择规格
    specChoose: function specChoose() {
      // this.$refs.cartFiltrate.show = true;
      if (this.specList.length > 1) {
        this.cartShow = true;
        this.type = 0;

        if (!this.goodsDetailId && this.specList) {
          this.goodsDetailId = this.specList[0].goodsDetailId;
        }
      }
    },
    //规格item变化
    specChange: function specChange(result) {
      console.log(result);
      this.goodsDetailId = result.goodsDetailId;
    },
    buyOrder: function buyOrder() {
      var orderObj = {};
      orderObj.goodsId = this.prdObj.goodsId;
      orderObj.goodsName = this.prdObj.goodsName;
      orderObj.goodsQty = this.num;
      orderObj.price = this.nowGoodsDetail.price;
      orderObj.freight = this.prdObj.freight;
      orderObj.subFreight = this.prdObj.subFreight;
      orderObj.isReal = this.isReal;
      orderObj.goodsSpecifitionId = this.nowGoodsDetail.goodsDetailId;
      orderObj.goodsSpecifition = this.nowGoodsDetail.specification;
      orderObj.picUrl = this.prdObj.mainImageUrl;
      var orderInfoList = [];
      orderInfoList[0] = orderObj;
      console.log(orderInfoList);
      var orderInfo = {};
      orderInfo.orderList = orderInfoList;
      orderInfo.isSubmit = true;
      this.MUTATION_MALL_ORDERINFOSURE(orderInfo);
      this.$router.push({
        name: 'MallOrderSure'
      });
    },
    getGoodsDetailAjax: function getGoodsDetailAjax(goodsId) {
      var _this2 = this;

      this.goodsId = goodsId;
      GetGoodsDetail(this.goodsId).then(function (data) {
        var imgArray = [];

        if (data.mainImageUrl) {
          imgArray.push({
            url: 'javascript:',
            img: data.mainImageUrl
          });
        }

        var _iterator2 = _createForOfIteratorHelper(data.bannerImage),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            imgArray.push({
              url: 'javascript:',
              img: item.imageUrl
            });
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        _this2.goodsName = data.goodsName;
        _this2.specList = data.scrmGoodsDetails;
        _this2.imgArray = imgArray;
        _this2.prdObj = data;

        if (data.scrmGoodsDetails.length == 1) {
          _this2.goodsDetailId = data.scrmGoodsDetails[0].goodsDetailId;
        } // this.nowGoodsDetail = this.specList[0];

      });
    },
    setShow: function setShow(val) {
      console.log(val);
      this.cartShow = val;
    },
    //点击购物车
    goCart: function goCart() {
      this.$router.push({
        name: 'MallShopCart'
      });
    }
  })
};